import axios, { AxiosInstance } from 'axios';
import { IError } from 'type/db';
import { getCookie } from 'utils/cookies';

export const api = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
});
export const report_api = axios.create({
	baseURL: process.env.REACT_APP_BATCH_API_URL,
});

const apiInterceptors = (axios_instance_arr: AxiosInstance[]) =>
	axios_instance_arr.forEach((item) => {
		// 헤더에 토큰 추가
		item.interceptors.request.use((config) => {
			const token = getCookie('imms_access_token');
			if (!token || !config.headers) return config;
			config.headers.Authorization = `Bearer ${token}`;
			return config;
		});

		// 헤더에 워크스페이스 코드 추가
		item.interceptors.request.use((config) => {
			const code = getCookie('imms_workspace_code');
			if (!code || !config.headers) return config;
			config.headers['Ft-Workspace'] = code;
			return config;
		});

		// 에러 응답 내에서 데이터만 반환
		item.interceptors.response.use(
			function (response) {
				return response;
			},
			function (error: IError) {
				console.log(error);
				return Promise.reject(error.response.data);
			},
		);
	});

apiInterceptors([api, report_api]);
